import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useUpdateProject = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.put("/Project/UpdateProject", formData);
  });
  return mutation;
};
export default useUpdateProject;
